import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import QuoteProductDetail from '../../../quotes/entities/quoteProductDetail';
import ProductBucketQuoteProductSelectionItemViewComponent from '../../../quotes/review/quote-products/ProductBucketQuoteProductSelectionItemViewComponent';

class ProductBucketQuoteProductSelectionViewComponent extends React.Component {
  static propTypes = {
    entity: PropTypes.instanceOf(QuoteProductDetail).isRequired,
    products: PropTypes.array.isRequired,
  };

  render() {
    const { entity, products } = this.props;
    return (
      <Fragment>
        <table className={`table table-mobile step3-product-table`}>
          <tbody>
            {products.map((product, idx) => (
              <ProductBucketQuoteProductSelectionItemViewComponent
                key={idx}
                product={product}
                entity={entity}
              />
            ))}
          </tbody>
        </table>
      </Fragment>
    );
  }
}

export default ProductBucketQuoteProductSelectionViewComponent;
